import { getEnv } from '@/constants';
import { getCachedUberData } from '@/services/event.service';
import loggerService from '@/services/logger.service';

export function isCventLinkedEvent(): boolean {
  const uberData = getCachedUberData();
  return !!uberData?.event?.[0]?.cvent_event_id;
}

/**
 * Initiates a Cvent OAuth redirect for the given event if it is Cvent-linked.
 *
 * Returns true if the redirect was initiated (caller should halt its own navigation).
 * Returns false if the event is not Cvent-linked, or if the OAuth authorize call
 * fails — in both cases the caller should fall back to the standard /auth route.
 */
export async function redirectViaCventIfLinked(eventId: string): Promise<boolean> {
  const uberData = getCachedUberData();
  const event = uberData?.event?.[0];

  if (!event?.cvent_event_id) {
    return false;
  }

  const baseUrl = getEnv('VUE_APP_BACKEND_SERVER').replace(/\/+$/, '');
  const url = `${baseUrl}/event/${eventId}/oauth2/authorize`;

  try {
    const res = await fetch(url, { method: 'GET', mode: 'cors', cache: 'no-cache' });
    const data = await res.json();
    if (res.ok && data.redirectUrl) {
      loggerService.info('[CventOAuth] Redirecting to Cvent login', { eventId, redirectUrl: data.redirectUrl });
      globalThis.location.href = data.redirectUrl;
      return true;
    }
    loggerService.error('[CventOAuth] Authorize endpoint returned an error', { status: res.status, data });
  } catch (err) {
    loggerService.error('[CventOAuth] Authorize request failed', err);
  }

  return false;
}
